const getters = {
  accessedRoutes: state => state.user.accessedRoutes,
}

export default getters
